import { render, staticRenderFns } from "./ActivitiesList.vue?vue&type=template&id=0f5827c9&scoped=true&"
import script from "./ActivitiesList.vue?vue&type=script&lang=js&"
export * from "./ActivitiesList.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesList.vue?vue&type=style&index=0&id=0f5827c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5827c9",
  null
  
)

export default component.exports